import Fluxxor from 'fluxxor';

export const constants = {
  SET_LANGUAGECODE: 'TRANSLATIONS:SET_LANGUAGECODE',
};

const RELOAD_COOLDOWN = 5000; // 5 seconds cooldown
const LAST_RELOAD_KEY = 'lastReloadTime';

export const TranslationStore = Fluxxor.createStore({
  initialize() {
    this.languageCode = 'en';
    this.languageCodes = [
      { code: 'en', name: 'English' },
      { code: 'es', name: 'Español' },
      { code: 'nl', name: 'Nederlands' },
      { code: 'de', name: 'Deutsch' },
      { code: 'fr', name: 'Français' },
      { code: 'it', name: 'Italiano' },
    ].sort((a, b) => a.name.localeCompare(b.name));

    this.bindActions(constants.SET_LANGUAGECODE, this.setLanguageCode);
  },

  setLanguageCode(languageCode) {
    if (
      this.languageCode !== languageCode ||
      window.langCode !== languageCode
    ) {
      this.languageCode = languageCode;
      window.langCode = languageCode;

      const currentTime = Date.now();
      const lastReloadTime = parseInt(
        localStorage.getItem(LAST_RELOAD_KEY) || '0',
        10,
      );

      if (currentTime - lastReloadTime > RELOAD_COOLDOWN) {
        localStorage.setItem(LAST_RELOAD_KEY, currentTime.toString());
        window.location.reload();
      } else {
        console.log('Reload prevented due to cooldown');
      }
    }
    this.emit('change');
  },

  getLanguageCode() {
    return this.languageCode;
  },

  getLanguageCodes() {
    return this.languageCodes;
  },

  getLangNameForCode(languageCode) {
    const lang = this.languageCodes.find(
      (language) => language.code === languageCode,
    );
    return lang ? lang.name : '';
  },
});
